import { UserManagementTable } from '@/components/users/UserManagementTable'
import { CreateUserDialog } from '@/components/users/CreateUserDialog'

export function Users() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Members</h1>
          <p className="text-muted-foreground">Manage member accounts in the member portal</p>
        </div>
        <CreateUserDialog />
      </div>

      <UserManagementTable />
    </div>
  )
}
